import moment from 'moment';

export default function convertMomentToHoursMins(value, timeNow): string {
  const hours = moment(moment().add(value, 'seconds')).diff(timeNow, 'hours');
  const newValueMins = moment(moment().add(value, 'seconds')).diff(timeNow, 'minutes');
  let mins = (newValueMins % 60).toString();
  if (mins.toString().length === 1) mins = `0${mins}`;
  return `${hours}:${mins}`;
}
